import React from 'react';

const services = [
  { 
    title: "Cloud Strategy & Adoption", 
    description: "Crafting bespoke cloud roadmaps and facilitating seamless migration and adoption for enterprise-level clients.",
    features: ["Multi-Cloud Strategy", "Cloud Readiness Assessment", "Migration Planning & Execution", "Cost Optimization"]
  },
  { 
    title: "AI & Machine Learning", 
    description: "Leveraging cutting-edge AI and ML to unlock data-driven insights and automate complex business processes.",
    features: ["Custom Model Development", "LLM Integration & Fine-Tuning", "RAG Systems", "AI Ethics & Governance"]
  },
  { 
    title: "DevOps & CI/CD", 
    description: "Streamlining development pipelines with robust automation, continuous integration, and delivery practices.",
    features: ["Automated CI/CD Pipelines", "Infrastructure as Code (IaC)", "Containerization & Orchestration", "GitOps Strategy"]
  },
  { 
    title: "Data Analytics & Insights", 
    description: "Transforming raw data into actionable intelligence with advanced analytics and visualization.",
    features: ["Data Warehousing", "BI Dashboards", "Predictive Analytics", "Real-time Data Processing"]
  },
  { 
    title: "Enterprise Security", 
    description: "Implementing comprehensive security protocols and compliance measures to protect your digital assets.",
    features: ["Cloud Security Posture Management", "Zero Trust Architecture", "Threat Detection & Response", "Compliance Automation"]
  },
  { 
    title: "API Platform Services", 
    description: "Building scalable and secure API platforms to power your digital ecosystem and connect services.",
    features: ["API Design & Development", "API Gateway Management", "Developer Portals", "API Security & Monetization"]
  },
];

const ServicesPage = () => {
  return (
    <div className="px-8 py-20 animate-fadeIn">
      <h1 className="text-6xl font-bold text-center mb-6">Our Services</h1>
      <p className="text-xl text-center text-brand-text-dark max-w-3xl mx-auto mb-20">
        We offer a full spectrum of cloud and AI services designed to accelerate your innovation and growth.
      </p>
      <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
        {services.map((service, index) => (
          <div key={index} className="bg-brand-gray p-8 rounded-xl border border-brand-light-gray flex flex-col">
            <h3 className="text-3xl font-bold mb-4 text-brand-primary">{service.title}</h3>
            <p className="text-brand-text-dark mb-6 flex-grow">{service.description}</p>
            <ul className="space-y-2">
              {service.features.map(feature => (
                <li key={feature} className="flex items-center">
                  <svg className="w-5 h-5 mr-3 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesPage; 